module.exports = __webpack_public_path__ + "img/bg.f2cf405d.jpg";